module.exports = __webpack_public_path__ + "static/media/sniper-3.4995fb41.png";